import React from 'react';
import { useTranslation } from 'react-i18next';
import RedemptionIcon from '@/assets/icons/redemption-shopping-icon.svg';
import { TagSubmissionHistoryItem } from '@/services/tagSubmissionHistory.service';
import './HistoryItem.scss';

interface TagSubmissionItemProps {
  item: TagSubmissionHistoryItem;
  isLastVisible?: boolean;
}

const TagSubmissionItem: React.FC<TagSubmissionItemProps> = ({ item, isLastVisible = false }) => {
  const { t } = useTranslation('home');

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric'
    }).format(date);
  };

  return (
    <div className={`history-item ${isLastVisible ? 'history-item--last-visible' : ''} history-item--type-tag-submission`}>
      <div className="history-item__timeline">
        <div className="history-item__icon">
          <img src={RedemptionIcon} alt="timeline icon" />
        </div>
        <div className="history-item__date">{formatDate(item.lastModifiedDate)}</div>
      </div>
      
      <div className="history-item__content">
        <div className="history-item__main">
          <div className="history-item__tags">
            {item.subtype && (
              <span className="history-item__tag history-item__tag--sub">{item.subtype}</span>
            )}
          </div>

          <div className={`history-item__client-info ${item.status.toLowerCase() === 'rejected' ? 'history-item__client-info--rejected' : ''}`}>
            <h3 className="history-item__title">
              {item.clientName || t('history.unknownClient')}
              {item.orderNumber && ` - ${t('history.order')} ${item.orderNumber}`}
            </h3>
            <div className="history-item__address">
              <span>{t('history.labels.projectAddress')}:</span> {item.deliveryAddrStreet}, {item.deliveryAddrCity}, {item.deliveryAddrState} {item.deliveryAddrPostalCode}
            </div>
          </div>
        </div>
        
        <div className="history-item__status-container">
          <span className="history-item__status-label">{t('history.labels.status')}:</span>
          <div className={`history-item__status history-item__status--${item.status.toLowerCase().replace(/\s+/g, '-')}`}>
            {item.status}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TagSubmissionItem;
